import React from "react";
import { Marker } from "@react-google-maps/api";

const MARKER_IMAGE = "/images/marker.png";
const INDICATE_MARKER_IMAGE = "/images/marker-indicator.png";
const MARKER_SIZE_WIDTH = 56;
const MARKER_SIZE_HEIGHT = 84;
const MARKER_RESIZE_WIDTH = 28;
const MARKER_RESIZE_HEIGHT = 42;
const MARKER_TIP_INSET = 2;
const MARKER_ANCHOR_X = MARKER_RESIZE_WIDTH / 2;
const MARKER_ANCHOR_Y = MARKER_RESIZE_HEIGHT - MARKER_TIP_INSET;

function getMarkerIcon(imageUrl) {
  return {
    url: imageUrl,
    size: new google.maps.Size(MARKER_SIZE_WIDTH, MARKER_SIZE_HEIGHT),
    scaledSize: new google.maps.Size(MARKER_RESIZE_WIDTH, MARKER_RESIZE_HEIGHT),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(MARKER_ANCHOR_X, MARKER_ANCHOR_Y),
  };
}

function MapMarker({ result, isSelected, isHighlighted, onClick }) {
  const icon = React.useMemo(
    () => getMarkerIcon(isHighlighted ? INDICATE_MARKER_IMAGE : MARKER_IMAGE),
    [isHighlighted]
  );

  const handleClick = React.useCallback(() => {
    if (onClick) onClick(result);
  }, [onClick, result]);

  const isTestOrDev = typeof window !== "undefined" &&
    (window.RAILS_ENV === "TEST" || window.RAILS_ENV === "development");
  const title = (result.addressLine || "") + (isTestOrDev ? " - GOOGLE MAPS MARKER" : "");

  return (
    <Marker
      position={result.latLng}
      icon={icon}
      title={title}
      optimized={!isTestOrDev}
      onClick={handleClick}
    />
  );
}

export default React.memo(MapMarker);
